import { BoxxGenericState, getGenericInitialState } from '@boxx/core';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import {
  IProfileStateError,
  IProfileStateSuccess,
} from '../core/IStateErrorSuccess';
import { ProfileModel } from '../models/profile.model';
import * as fromActions from './profile.actions';

export type ProfileState = BoxxGenericState<
  ProfileModel,
  IProfileStateSuccess,
  IProfileStateError
>;

const initialState: ProfileState = {
  ...getGenericInitialState(),
  data: ProfileModel.empty(),
};

const reducer: ActionReducer<ProfileState> = createReducer(
  initialState,
  on(
    fromActions.loadProfileBeginAction,
    fromActions.updateProfileBeginAction,
    (state): ProfileState => ({
      ...state,
      error: null,
      success: null,
      isLoading: true,
    })
  ),
  on(
    fromActions.loadProfileSuccessAction,
    (state, action): ProfileState => ({
      ...state,
      data: action.payload,
      isLoading: false,
      fetched: true,
    })
  ),
  on(
    fromActions.loadProfileFailAction,
    (state, action): ProfileState => ({
      ...state,
      isLoading: false,
      error: { after: getErrorActionType(action.type), error: action.errors },
      fetched: true,
    })
  ),
  on(
    fromActions.updateProfileFailAction,
    (state, action): ProfileState => ({
      ...state,
      isLoading: false,
      error: { after: getErrorActionType(action.type), error: action.errors },
    })
  ),

  on(
    fromActions.updateProfileSuccessAction,
    (state, action): ProfileState => ({
      ...state,
      data: action.response,
      isLoading: false,
      success: { after: getSuccessActionType(action.type) },
    })
  )
);

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function getErrorActionType(type: fromActions.ProfileActionTypes) {
  let action: 'GET' | 'UPDATE' | 'UNKNOWN' = 'UNKNOWN';

  switch (type) {
    case fromActions.ProfileActionTypes.loadProfileFail:
      action = 'GET';
      break;
    case fromActions.ProfileActionTypes.updateProfileFail:
      action = 'UPDATE';
      break;
  }

  return action;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function getSuccessActionType(type: fromActions.ProfileActionTypes) {
  let action: 'GET' | 'UPDATE' | 'UNKNOWN' = 'UNKNOWN';

  switch (type) {
    case fromActions.ProfileActionTypes.loadProfileSuccess:
      action = 'GET';
      break;
    case fromActions.ProfileActionTypes.updateProfileSuccess:
      action = 'UPDATE';
      break;
  }

  return action;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function profileReducer(
  state: ProfileState | undefined,
  action: Action
) {
  return reducer(state, action);
}
